import React from 'react';
import { LockIcon } from 'lucide-react';
import { SectionHeading, SpecSection } from './SectionHeading';
import { LevelBadge } from '../ui/LevelBadge';
import { AgentMark } from '../ui/AgentMark';
import { actionLevels } from '../../data/levels';
import { houseModes } from '../../data/houseModes';
import { agents } from '../../data/agents';
import { fixedRules } from '../../data/rules';
export function RulesSection() {
  return <SpecSection id="regels" data-id="element-1138" data-mp="1jo5x36pkkb4v">
      <SectionHeading id="regels" index={5} title="Vaste regels" intro="Deze regels komen uit het plan en gelden op elk scherm: Anna-modus, telefoon en Beheer." data-id="element-1139" data-mp="1jrjwq76um68m" />
      <p className="mt-8 inline-flex items-center gap-2.5 rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 text-[14px] font-medium text-ink-soft" data-id="element-1140" data-mp="1ootxuk3lo6ca">
        <LockIcon className="h-4 w-4 text-accent" aria-hidden data-id="element-1141" data-mp="3uiadtwobrgt3" />
        Niet hernoemen, niet herordenen, geen alternatieven verzinnen.
      </p>

      <div className="mt-14" data-id="element-1142" data-mp="1q65zsyr2pjts">
        <h3 className="text-[20px] font-semibold text-ink" data-id="element-1143" data-mp="1q77ereb7mqgs">Actieniveaus</h3>
        <p className="mt-1 text-[15px] text-ink-muted" data-id="element-1144" data-mp="1v4zg0yxqvoxn">Precies deze vier. Elke actie draagt er één als badge.</p>
        <div className="mt-6 overflow-x-auto" data-id="element-1145" data-mp="2042bpsru4isy">
          <table className="w-full min-w-[820px] text-left" data-id="element-1146" data-mp="20293i91kpqiu">
            <thead data-id="element-1147" data-mp="24w3vdzrc1bt0">
              <tr className="border-b border-white/[0.08] text-[13px] text-ink-muted" data-id="element-1148" data-mp="24wn18i3pk9qo">
                <th scope="col" className="w-[220px] py-3 pr-6 font-medium" data-id="element-1149" data-mp="29tdjnc2zjhf9">Badge</th>
                <th scope="col" className="py-3 pr-6 font-medium" data-id="element-1150" data-mp="2dupatm1icapk">Betekenis</th>
                <th scope="col" className="py-3 pr-6 font-medium" data-id="element-1151" data-mp="2iubp7yt2nwzy">Voorbeelden</th>
                <th scope="col" className="w-[220px] py-3 font-medium" data-id="element-1152" data-mp="2ntwlu2krrt9i">Bediening</th>
              </tr>
            </thead>
            <tbody data-id="element-1153" data-mp="ohc5pulkmine">
              {actionLevels.map(l => <tr key={l.id} className="border-b border-white/[0.05] align-top" data-id="element-1154" data-mp="oj5a138poqs8">
                  <td className="py-5 pr-6" data-id="element-1155" data-mp="tg5ej9pwxlh8"><LevelBadge level={l.id} data-id="element-1156" data-mp="lf7mxns8qghj" /></td>
                  <td className="py-5 pr-6 text-[15px] leading-relaxed text-ink" data-id="element-1157" data-mp="lfz7m3kautt1">{l.rule}</td>
                  <td className="py-5 pr-6 text-[15px] leading-relaxed text-ink-soft" data-id="element-1158" data-mp="hexgka0jdo25">{l.examples}</td>
                  <td className="py-5 text-[15px] leading-relaxed text-ink-soft" data-id="element-1159" data-mp="ve6iq5rwqhn4">{l.control}</td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-16 grid gap-16 lg:grid-cols-12" data-id="element-1160" data-mp="14d0fbw58n80o">
        <div className="lg:col-span-5" data-id="element-1161" data-mp="10cgjqx0bccgn">
          <h3 className="text-[20px] font-semibold text-ink" data-id="element-1162" data-mp="10bovk791ph0e">Huismodi</h3>
          <p className="mt-1 text-[15px] text-ink-muted" data-id="element-1163" data-mp="1e4ehycshkny1">Precies deze vijf.</p>
          <ul className="mt-6 space-y-5" data-id="element-1164" data-mp="194s35yx0ezn4">
            {houseModes.map(m => {
            const Icon = m.icon;
            return <li key={m.id} className="flex gap-4" data-id="element-1165" data-mp="1o33z23ck64d8">
                  <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-white/[0.05] text-ink-soft" data-id="element-1166" data-mp="1j2y8kqi0ynwq">
                    <Icon className="h-4 w-4" strokeWidth={1.75} aria-hidden data-id="element-1167" data-mp="22o82gb4ukqjn" />
                  </span>
                  <div data-id="element-1168" data-mp="26qmnn1vzo2e3">
                    <p className="text-[16px] font-semibold text-ink" data-id="element-1169" data-mp="26p1qd4iai5cj">{m.id}</p>
                    <p className="text-[15px] leading-snug text-ink-soft" data-id="element-1170" data-mp="1spilckkrza4g">{m.description}</p>
                  </div>
                </li>;
          })}
          </ul>
        </div>

        <div className="lg:col-span-7" data-id="element-1171" data-mp="1j0ij8saz7ym1">
          <h3 className="text-[20px] font-semibold text-ink" data-id="element-1172" data-mp="1izh9qs9lzk6f">Agents</h3>
          <p className="mt-1 text-[15px] text-ink-muted" data-id="element-1173" data-mp="1nsinuy1zrfoy">Precies deze acht, elk met een eigen kleur en lijnicoon.</p>
          <ul className="mt-6 grid gap-x-8 gap-y-5 sm:grid-cols-2" data-id="element-1174" data-mp="1a1nfrnzbh2mf">
            {agents.map(a => <li key={a.id} className="flex gap-4" data-id="element-1175" data-mp="1ezf64dkbcgoi">
                <AgentMark agentId={a.id} data-id="element-1176" data-mp="101egg1a1312t" />
                <div className="min-w-0" data-id="element-1177" data-mp="102oewrksmb9z">
                  <p className="flex items-baseline gap-2 text-[16px] font-semibold text-ink" data-id="element-1178" data-mp="150px7aaea6ke">
                    {a.name}
                    <span className="font-mono text-[12px] font-normal text-ink-muted" data-id="element-1179" data-mp="28avcvymm2apv">{a.color}</span>
                  </p>
                  <p className="text-[15px] leading-snug text-ink-soft" data-id="element-1180" data-mp="23dc0735ka601">{a.scope}</p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mt-16 border-t border-white/[0.07] pt-10" data-id="element-1181" data-mp="1tlzaah3bppwn">
        <h3 className="text-[20px] font-semibold text-ink" data-id="element-1182" data-mp="1onnza31al9cu">Altijd</h3>
        <dl className="mt-6 grid gap-x-10 gap-y-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-1183" data-mp="1oltaueqtaz40">
          {fixedRules.map(r => <div key={r.title} data-id="element-1184" data-mp="1fn7yx2fuiic7">
              <dt className="text-[16px] font-semibold text-ink" data-id="element-1185" data-mp="1fmg3psq5ummg">{r.title}</dt>
              <dd className="mt-1 text-[15px] leading-relaxed text-ink-soft" data-id="element-1186" data-mp="1aoelfa0k6rc1">{r.body}</dd>
            </div>)}
        </dl>
      </div>
    </SpecSection>;
}